import { UserAccount } from '@iot-platform/models/common';
import { createReducer, on } from '@ngrx/store';
import { PreferencesActions, ProfileActions } from '../actions';

export const userProfileDbFeatureKey = 'userProfileDb';

export interface State {
  currentUser: UserAccount;
  maxApiKeysReached: boolean;
  apiKeys: any[];
  detailedApiKey: any;
}

export const initialState: State = {
  currentUser: null,
  maxApiKeysReached: false,
  apiKeys: [],
  detailedApiKey: null
};

export const reducer = createReducer(
  initialState,
  on(ProfileActions.loadUserProfile, (state: State) => ({ ...state })),
  on(ProfileActions.loadUserProfileSuccess, (state: State, { user }) => ({ ...state, currentUser: user })),
  on(ProfileActions.saveUserProfileSuccess, (state: State, { updatedUser }) => ({
    ...state,
    currentUser: updatedUser
  })),
  on(PreferencesActions.saveUserPreferencesSuccess, (state: State, { user }) => ({ ...state, currentUser: user }))
);

export const getCurrentUser = (state: State) => state.currentUser;
